<template>
  <div>

    <Breadcrumbs :title="project && budget ? project.translation['en'].name + ' / ' + budget.name : '&nbsp;'"/>

    <ConfirmModal ref="projectRemoveModal" :okButtonText="$t('message.delete')"
                  @ok-handle="removeFromDatabase"></ConfirmModal>

    <b-modal id="modal-duplicate-budget" :title="$t('message.budget_duplicate')"
             :ok-title="$t('message.budget_duplicate')" :cancel-title="$t('message.cancel')" class="theme-modal"
             @ok="handleDuplicate"
             no-close-on-backdrop ok-only>
      <form @submit.stop.prevent="">

        <b-form-group
            :label="$t('message.profile_name')"
            label-for="name-input"
            :invalid-feedback="$t('message.plan_modal_invalid_name')"
            :state="duplicateNameError"
        >
          <b-form-input
              id="name-input"
              v-model="duplicateName"
              :state="duplicateNameError"
              required
          ></b-form-input>
        </b-form-group>
      </form>
    </b-modal>
    <b-modal id="modal-new-finance-item"
             ok-only
             :title="record.id ? $t('message.budget_update_item') : $t('message.budget_create_new')"
             :ok-title="record.id ? $t('message.budget_update_item') : $t('message.budget_create_item')"
             class="theme-modal" :cancel-title="$t('message.cancel')"
             @ok="handleOk"
             no-close-on-backdrop>
      <form @submit.stop.prevent="handleSubmit">
        <b-form-group
            :label="$t('message.profile_name')"
            label-for="name-input"
            :invalid-feedback="$t('message.plan_modal_invalid_name')"
            :state="financeItemErrors.name"
        >
          <b-form-input
              id="name-input"
              v-model="record.name"
              :state="financeItemErrors.name"
              required
          ></b-form-input>
        </b-form-group>

        <b-form-group
            v-show="record.section != 'capital'"
            :label="$t('message.budget_item_type')"
            label-for="name-input"
            :invalid-feedback="$t('message.budget_item_type_error')"
        >
          <b-form-select v-model="record.type" :options="itemTypes" required></b-form-select>
        </b-form-group>

        <b-form-group
            v-if="this.budget"
            :label="$t('message.budget_finance_start_date')"
            label-for="name-input"
            :invalid-feedback="$t('message.budget_start_date_error')"
            :state="financeItemErrors.start"
        >

          <vue-monthly-picker
              :state="financeItemErrors.start"
              :min="moment(this.budget.start)"
              :max="moment(this.budget.end)"
              :monthLabels="monthsArray"
              v-model="record.start">
          </vue-monthly-picker>

        </b-form-group>

        <b-form-group
            v-if="this.budget && this.budget.start && record.type == 'Recurring'"
            :label="$t('message.budget_finance_end_date')"
            label-for="name-input"
            :invalid-feedback="$t('message.budget_end_date_error')"
            :state="financeItemErrors.end"
        >

          <vue-monthly-picker
              :max="moment(this.budget.end)"
              :clearOption="false"
              :disabled="record.start == ''"
              :state="financeItemErrors.end"
              :monthLabels="monthsArray"
              v-model="record.end">
          </vue-monthly-picker>
        </b-form-group>

        <b-form-group
            :label="$t('message.budget_amount_euro')"
            label-for="name-input"
            :invalid-feedback="$t('message.budget_amount_error')"
        >
          <b-form-input
              id="name-input"
              min="1"
              type="number"
              v-model="record.amount"
              required
          ></b-form-input>
        </b-form-group>

        <b-form-group
            :label="$t('message.budget_category')"
            label-for="section-input"
        >

          <vue-simple-suggest
              v-model="record.cluster"
              :list="simpleSuggestionList"
              :filter-by-query="true">
          </vue-simple-suggest>
        </b-form-group>

      </form>
    </b-modal>

    <div class="p-10 pt-0">
<!--      <h5 style="line-height: 30px;" v-if="budget">{{ budget.name }}</h5>-->
      <b-tabs v-if="budget && budget.categories.length" content-class="mt-3" justified lazy>

        <b-tab :title="$t('message.budget_summary')">
          <BudgetSummary
              :steps="stepsPerTab[1]"
              v-if="budget"
              :budget="budget">
          </BudgetSummary>
        </b-tab>

        <b-tab v-for="(cat, index) in budget.categories" :key="cat.id" :title="$t('message.budget_' + cat.name)">
          <BudgetSection :steps="stepsPerTab[index + 2]" :ref="'cat_' + cat.id" v-if="cat && budget" :cat="cat"
                         :budget="budget" :key="cat.id"
                         :color="colors[index]"
                         @openFinanceItemModal="openFinanceItemModal"></BudgetSection>
        </b-tab>

        <b-tab :title="$t('message.budget_settings')">

          <div
              style="background-color: white;padding: 20px;margin-top: -16px;border: 1px solid #dee2e6;border-top: none">

            <div v-if="stepsPerTab && stepsPerTab['5'].length" class="mb-4">
              <h6>{{ $t('message.budget_related_steps') }}</h6>
              <button type="button" class="btn btn-sm btn-primary full-width mr-1 mb-2"
                      style="width: 100%;text-align: center"
                      v-for="step in stepsPerTab['5']" :key="step.id">
                {{ step.translation['en'].name }}
              </button>
            </div>

            <form ref="form" @submit.stop.prevent="handleSubmit" style="max-width: 466px;margin: 50px auto">
              <b-form-group
                  :label="$t('message.profile_name')"
                  label-for="name-input"
                  :invalid-feedback="$t('message.plan_modal_invalid_name')"
                  :state="budgetErrors.name"
              >
                <b-form-input
                    id="name-input"
                    v-model="editBudget.name"
                    :state="budgetErrors.name"
                    required
                ></b-form-input>
              </b-form-group>

              <b-form-group
                  :label="$t('message.budget_start_date')"
                  label-for="name-input"
                  :invalid-feedback="$t('message.budget_start_date_error')"
              >

                <vue-monthly-picker
                    :clearOption="false"
                    :monthLabels="monthsArray"
                    v-model="editBudget.start"
                    required
                >
                </vue-monthly-picker>
              </b-form-group>
              <b-form-group
                  v-if="editBudget.start != ''"
                  :label="$t('message.budget_end_date')"
                  label-for="name-input"
                  invalid-feedback="End date is required"
              >

                <vue-monthly-picker
                    :clearOption="false"
                    :disabled="editBudget.start == ''"
                    :monthLabels="monthsArray"
                    :min="editBudget.start"
                    required
                    v-model="editBudget.end">
                </vue-monthly-picker>
              </b-form-group>

              <b-form-group
                  :label="$t('message.budget_inflation') + ' (' + $t('message.per_year') + ')'"
                  label-for="name-input"
                  invalid-feedback="Group is required"
              >
                <b-form-spinbutton id="burn-rate" v-model="editBudget.burn_rate" min="-100" max="100"
                                   step="1"></b-form-spinbutton>

              </b-form-group>

              <b-form-group
                  :label="$t('message.budget_earn') + ' (' + $t('message.per_year') + ')'"
                  label-for="name-input"
                  invalid-feedback="Group is required"
              >
                <b-form-spinbutton id="earn-rate" v-model="editBudget.earn_rate" min="-100" max="100"
                                   step="1"></b-form-spinbutton>
              </b-form-group>

              <b-button block variant="primary" class="btn btn-sm" @click="updateBudget">
                {{ $t('message.budget_update') }}
              </b-button>

              <b-button block variant="primary" class="btn btn-sm" @click="duplicateBudget">
                {{ $t('message.budget_duplicate') }}
              </b-button>

              <b-button block variant="primary" class="btn btn-sm" @click="setDefaultBudget">
                {{ $t('message.budget_default') }}
              </b-button>

              <b-button block variant="danger" class="btn btn-sm" @click="deleteBudget">
                {{ $t('message.budget_remove') }}
              </b-button>
            </form>

          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>


<script>

import BudgetSection from "@/pages/Budget/BudgetSection";
import VueMonthlyPicker from 'vue-monthly-picker'
import BudgetSummary from '@/pages/Budget/BudgetSummary'
import VueSimpleSuggest from 'vue-simple-suggest/lib'
import ConfirmModal from "../Shared/ConfirmModal";

export default {
  name: "SingleProjectBudget",
  components: {BudgetSection, VueMonthlyPicker, BudgetSummary, VueSimpleSuggest, ConfirmModal},
  data() {
    return {
      project: null,
      randomKey: Math.random() * 100,
      duplicateName: '',
      duplicateNameError: null,
      stepsPerTab: {
        '1': [],
        '2': [],
        '3': [],
        '4': [],
        '5': []
      },
      colors: ['#6a0303', '#265E04FF', '#073b95'],
      itemTypes: ['Recurring', 'One-time'],
      periodTypes: ['Monthly', 'Quarterly', 'Yearly'],
      budget: null,
      record: {
        name: "",
        start: '',
        end: '',
        amount: 1,
        type: 'One-time',
        period: 'Monthly',
        growth: 0,
        rate: 'Monthly'
      },
      customError: {
        nameState: null,
        startDate: null,
        endDate: null
      },

      financeItemErrors: {
        name: null,
        start: '',
        end: '',
      },
      budgetErrors: {
        name: null,
        start: '',
        end: '',
      },
      editBudget: null,
      simpleSuggestionList: []
    }
  },
  created() {
    this.getSingleBudget()
  },
  methods: {

    setDefaultBudget() {

      let data = {
        id: this.$route.params.budgetId,
        decision: 1
      }

      this.$store.dispatch('budget/setDefault', data)
    },

    async removeFromDatabase() {
      await this.$store.dispatch('budget/delete', this.$route.params.budgetId)

      this.$router.push({
        name: "ProjectBudget", params: {
          id: this.$route.params.id
        }
      })

    },
    deleteBudget() {
      this.$refs['projectRemoveModal'].openModal(this.record, this.$t('message.budget_remove'), this.$t('message.delete_this_record'), this.$t('message.are_you_sure'))
    },

    duplicateBudget() {
      this.duplicateNameError = null
      this.$bvModal.show('modal-duplicate-budget')
    },

    async handleDuplicate(bvModalEvt) {

      bvModalEvt.preventDefault()
      this.duplicateNameError = null

      if (this.duplicateName == '') {
        this.duplicateNameError = false
        return
      }

      let updateObject = {
        id: this.budget.id,
        description: 'description',
        currency: 'EURO',
        name: this.duplicateName,
        burn_rate: this.budget.burn_rate,
        earn_rate: this.budget.earn_rate,
        start: this.budget.start,
        end: this.budget.end,
        plan_id: this.budget.plan_id
      }

      let response = await this.$store.dispatch('budget/duplicate', updateObject)

      this.$router.push({
        name: "SingleProjectBudget", params: {
          id: this.$route.params.id,
          budgetId: response.data.result.id
        }
      })

    },

    async getSingleBudget() {

      this.$store.dispatch('shared/setLoading', true)

      this.project = await this.$store.dispatch('projects/getProject', this.$route.params.id)
      this.planSteps = await this.$store.dispatch('plan/loadSteps', {
        groupId: this.project.group_id,
        lang: this.$i18n.locale
      })

      this.stepsPerTab = {
        '1': this.planSteps.filter((item) => {
          return item.budget && item.budget == 99991
        }),
        '2': this.planSteps.filter((item) => {
          return item.budget && item.budget == 99992
        }),
        '3': this.planSteps.filter((item) => {
          return item.budget && item.budget == 99993
        }),
        '4': this.planSteps.filter((item) => {
          return item.budget && item.budget == 99994
        }),
        '5': this.planSteps.filter((item) => {
          return item.budget && item.budget == 99995
        }),
      }

      this.budget = await this.$store.dispatch("budget/getSingle", this.$route.params.budgetId)

      this.editBudget = Object.assign({}, this.budget)
      this.editBudget.start = this.moment(this.editBudget.start)
      this.editBudget.end = this.moment(this.editBudget.end)
      this.editBudget.burn_rate = Math.round(this.editBudget.burn_rate * 12)
      this.editBudget.earn_rate = Math.round(this.editBudget.earn_rate * 12)

    },

    async updateBudget() {

      if (!this.checkBudgetValidity()) {
        return
      }

      let updateObject = {
        id: this.editBudget.id,
        description: 'description',
        currency: 'EURO',
        name: this.editBudget.name,
        burn_rate: (Number.parseFloat(this.editBudget.burn_rate) / 12),
        earn_rate: (Number.parseFloat(this.editBudget.earn_rate) / 12),
        start: this.editBudget.start.startOf('month').format('YYYY-MM-DD'),
        end: this.editBudget.end.endOf('month').format('YYYY-MM-DD')
      }

      await this.$store.dispatch("budget/update", updateObject)

      this.getSingleBudget()
    },

    resetFinanceItem() {
      this.record = {
        name: "",
        start: '',
        end: '',
        amount: 1,
        type: 'One-time',
        period: 'Monthly',
        growth: 0,
        rate: 'Monthly'
      }

      this.financeItemErrors = {
        name: null,
        start: '',
        end: '',
      }

    },
    openFinanceItemModal(cat, item, autoSuggest) {

      this.simpleSuggestionList = autoSuggest;

      this.resetFinanceItem()

      if (item) {

        this.record = {
          id: item.id,
          name: item.name,
          start: item.start,
          end: '',
          amount: item.amount,
          type: item.type,
          period: item.period,
          growth: 0,
          rate: 'Monthly',
          cluster: item.cluster
        }

        if (item.type == 'Recurring') {
          setTimeout(() => {
            this.record.end = item.end
          }, 100)

        }
      }

      this.record.budget_category_id = cat.id;
      this.record.section = cat.name.toLowerCase();

      this.$bvModal.show('modal-new-finance-item')

    },

    checkBudgetValidity() {

      let valid = true;

      if (this.editBudget.name.trim() == '') {
        valid = false
        this.budgetErrors.name = false
      } else {
        this.budgetErrors.name = true
      }

      return valid

    },

    checkFormValidity() {

      let valid = true;

      if (this.record.name.trim() == '') {
        valid = false
        this.financeItemErrors.name = false
      } else {
        this.financeItemErrors.name = true
      }

      if (this.record.start == '') {
        this.financeItemErrors.start = false
        valid = false
      } else {
        this.financeItemErrors.start = true
      }

      if (this.record.type == 'Recurring') {
        if (this.record.end == '') {
          this.financeItemErrors.end = false
          valid = false
        } else {
          this.financeItemErrors.end = true
        }
      }
      return valid
    },

    handleOk(bvModalEvt) {

      bvModalEvt.preventDefault()
      this.handleSubmit()

    },
    async handleSubmit() {

      if (!this.checkFormValidity()) {
        return
      }


      let record = Object.assign({}, this.record);

      record.description = 'description'
      record.currency = 'EURO'

      this.record.start = this.moment(this.record.start)

      record.start = this.record.start.startOf('month').format('YYYY-MM-DD')

      if (this.record.type == 'One-time') {
        record.end = this.record.start.endOf('month').format('YYYY-MM-DD')
      } else {

        this.record.end = this.moment(this.record.end)
        record.end = this.record.end.endOf('month').format('YYYY-MM-DD')
      }

      let result = null
      if (!record.id) {
        result = await this.$store.dispatch('budget/addSectionRecord', record)
      } else {
        result = await this.$store.dispatch('budget/updateSectionRecord', record)
      }

      let selectedCat = this.budget.categories.find((item) => {
        return item.id == this.record.budget_category_id
      })

      if (!record.id) {
        if (selectedCat) {
          if (!selectedCat.records) {
            selectedCat.records = []
          }
          selectedCat.records.push(result.data.result[0])
        }
      } else {

        let records = [...selectedCat.records]

        let selectedRecord = records.find((item) => {
          return item.id === record.id
        })

        selectedRecord.name = record.name
        selectedRecord.amount = record.amount
        selectedRecord.start = record.start
        selectedRecord.end = record.end
        selectedRecord.period = record.period
        selectedRecord.type = record.type
        selectedRecord.cluster = record.cluster

        this.$set(selectedCat, 'records', records)
      }

      this.$refs['cat_' + this.record.budget_category_id][0].initData()

      this.$nextTick(() => {
        this.$bvModal.hide('modal-new-finance-item')
      })

    }
  },
  watch: {
    'record.start': {
      handler() {
        this.record.end = ''
      },
      deep: true
    },
    'record.type': {
      handler() {
        this.record.end = ''
      },
      deep: true
    }
  },
  computed: {
    isLoading() {
      return this.$store.getters['shared/isLoading']
    },
    monthsArray() {
      return [this.$t('message.jan'), this.$t('message.fеb'), this.$t('message.mar'), this.$t('message.apr'), this.$t('message.may'), this.$t('message.jun'), this.$t('message.jul'), this.$t('message.aug'), this.$t('message.sep'), this.$t('message.oct'), this.$t('message.nov'), this.$t('message.dec')]
    }
  }
};

</script>